import { Flex } from '@mantine/core';
import type { QuestionMetrics } from '@repo/api-codegen';
import { memo, useCallback } from 'react';
import type { QuestionMetricCardType } from '../../types';
import {
	AccessRemovedIcon,
	AcknowledgedIncidentsIcon,
	InReviewIcon,
	NormalIcon,
	OpenIncidentsIcon,
} from '../icons';
import { MetricsOverviewCard } from '../MetricsOverviewCard';

export interface MetricsQuestionCardsProps {
	questionMetrics: QuestionMetrics;
	onMetricCardClick?: (metricType: QuestionMetricCardType) => void;
}

export const MetricsQuestionCards = memo(
	({ questionMetrics, onMetricCardClick }: MetricsQuestionCardsProps) => (
		<Flex py="lg" w="100%" justify="space-between" align="center" gap="md">
			<MetricsOverviewCard
				title="Open"
				value={questionMetrics?.status_counts?.open ?? 0}
				icon={OpenIncidentsIcon}
				onClick={useCallback(
					() => onMetricCardClick?.('Open'),
					[onMetricCardClick]
				)}
			/>
			<MetricsOverviewCard
				title="In progress"
				value={questionMetrics?.status_counts?.in_progress ?? 0}
				icon={AcknowledgedIncidentsIcon}
				onClick={useCallback(
					() => onMetricCardClick?.('InProgress'),
					[onMetricCardClick]
				)}
			/>
			<MetricsOverviewCard
				title="In review"
				value={questionMetrics?.status_counts?.in_review ?? 0}
				icon={InReviewIcon}
				onClick={useCallback(
					() => onMetricCardClick?.('InReview'),
					[onMetricCardClick]
				)}
			/>
			<MetricsOverviewCard
				title="Answered"
				value={questionMetrics?.status_counts?.answered ?? 0}
				icon={NormalIcon}
				onClick={useCallback(
					() => onMetricCardClick?.('Answered'),
					[onMetricCardClick]
				)}
			/>
			<MetricsOverviewCard
				title="Cancelled"
				value={questionMetrics?.status_counts?.cancelled ?? 0}
				icon={AccessRemovedIcon}
				onClick={useCallback(
					() => onMetricCardClick?.('Cancelled'),
					[onMetricCardClick]
				)}
			/>
		</Flex>
	)
);

MetricsQuestionCards.displayName = 'MetricsQuestionCards';
